import * as React from "react";
const ReportsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 8.64v9.75c0 3-1.79 4-4 4H8c-2.21 0-4-1-4-4V8.64c0-3.25 1.79-4 4-4 0 .62.25 1.18.66 1.59.41.41.97.66 1.59.66h3.5c1.24 0 2.25-1.01 2.25-2.25 2.21 0 4 .75 4 4Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16 4.64c0 1.24-1.01 2.25-2.25 2.25h-3.5c-.62 0-1.18-.25-1.59-.66C8.25 5.82 8 5.26 8 4.64c0-1.24 1.01-2.25 2.25-2.25h3.5c.62 0 1.18.25 1.59.66.41.41.66.97.66 1.59ZM8 13.39h4M8 17.39h8"
    />
  </svg>
);
export default ReportsIcon;
